import React from 'react';
import {withRouter} from 'react-router';
import {
  Row,
  Col,
  Icon,
  Grid,
  Panel,
  Button,
  PanelBody,
  PanelContainer,
} from '@sketchpixy/rubix';

import {googleLogin} from '../api/api';

@withRouter
export default class Login extends React.Component {

  googleLogin = (e) => {
    e.preventDefault();
    e.stopPropagation();
    googleLogin();
  };

  back(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.router.goBack();
  }

  render() {
    return (
        <div id='auth-container' className='login'>
          <div id='auth-row'>
            <div id='auth-cell'>
              <Grid>
                <Row>
                  <Col sm={4} smOffset={4} xs={10} xsOffset={1} collapseLeft collapseRight>
                    <PanelContainer controls={false}>
                      <Panel>
                        <PanelBody style={{padding: 0}}>
                          <div className='text-center bg-darkblue fg-white'>
                            <h3 style={{margin: 0, padding: 25}}>
                              Sign in to Admin Console
                            </h3>
                          </div>
                          <div>
                            <div style={{
                              padding: 25,
                              paddingTop: 0,
                              paddingBottom: 0,
                              margin: 'auto',
                              marginBottom: 25,
                              marginTop: 25,
                            }}>
                              <Button block outlined lg type='submit' bsStyle='blue' onClick={this.googleLogin}>
                                <Icon
                                    glyph='icon-fontello-googleplus-rect-1'
                                    className='fg-red'
                                    style={{fontSize: 24}}
                                />
                                {' '}Login with Google account
                              </Button>
                            </div>
                          </div>
                        </PanelBody>
                      </Panel>
                    </PanelContainer>
                  </Col>
                </Row>
              </Grid>
            </div>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Login.js